import React, { useState, useEffect } from 'react';
import { MonthlyOutgoingsView } from './MonthlyOutgoingsView';
import { monthlyOutgoingsAPI } from '../lib/api';

/**
 * Property Portfolio Monthly Outgoings.
 *
 * Thin wrapper over the shared MonthlyOutgoingsView. This scope has no global
 * entity selector, so it owns an entity <select> (slug-keyed options) and
 * passes the chosen slug down. All fetch/render/grouping/money logic lives in
 * the shared view, so it is never re-implemented here.
 *
 * Portfolio only (Fan, 2026-10-25: "limit to portfolio please"): the picker
 * lists the entities that pay property costs, defaults to all of them, and
 * the backend (scope=portfolio) keeps only property-linked rows on personal
 * and BR OS accounts (services/portfolio_outgoings_scope.py).
 */
export function MonthlyOutgoings({ eurGbpRate, entities }) {
  const [entityId, setEntityId] = useState('all');
  const [portfolioEntities, setPortfolioEntities] = useState(null);

  useEffect(() => {
    let cancelled = false;
    monthlyOutgoingsAPI.portfolioEntities()
      .then((res) => { if (!cancelled) setPortfolioEntities(res.data?.entities || []); })
      .catch(() => { if (!cancelled) setPortfolioEntities(null); });
    return () => { cancelled = true; };
  }, []);

  const options = portfolioEntities ?? entities ?? [];

  const entitySelect = (
    <select
      value={entityId}
      onChange={(e) => setEntityId(e.target.value)}
      className="h-9 rounded-md border border-input bg-background px-3 text-sm"
      data-testid="outgoings-entity-select"
    >
      <option value="all">All portfolio entities</option>
      {options.map((e) => (
        <option key={e.id} value={e.id}>{e.name}</option>
      ))}
    </select>
  );

  return (
    <MonthlyOutgoingsView
      eurGbpRate={eurGbpRate}
      entityId={entityId}
      scope="portfolio"
      controlSlot={entitySelect}
    />
  );
}
